import React from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const index = (props) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Typography
                className={props.className ?? undefined}
                style={props.style ?? undefined}
                variant={props.paragraphType}
                gutterBottom
            >
                {props.text}
            </Typography>
        </Box>
    )
}

export default index